import type { CallInfoType, CallTagType } from 'store/calls/calls.types';
import type { AccessRights, UserType } from 'store/user/user.types';
import type { MetaTags } from './CallsPage';
import type { CriteriasType, TemplateType } from 'store/search/search.types';
import { Page } from 'components/common/Criterias/types';

export interface CommonPropsType {
	callInfo: CallInfoType | null;
	expanded: boolean;
	loadCheckLists(callId: string): void;
	language: string;
	userInfo: UserType | null;
	isAuth: boolean | 'loading';
	solo?: boolean;
	isLoading?: boolean;
	showOpenLink?: boolean;
	metaTags?: MetaTags | undefined;
	accessRights: AccessRights | null;
}

export const enum TagTypeEnum {
	manual = 'manual',
}

export enum TagThemesTypes {
	gray = 'gray',
	blue = 'blue',
	purple = 'purple',
	orange = 'orange',
	lightBlue = 'lightBlue',
	green = 'green',
}

export type TagsWithCount = { tag: CallTagType; count: number };

export interface IOwnProps {
	blockTitle?: string;
	simpleListWithTitles: boolean;
	accessRights: AccessRights | null;
	language: string;
	activeCriterias: CriteriasType[];
	allCriterias: CriteriasType[];
	onTemplateSelectValueChange: (event: any) => void;
	currentTemplate?: TemplateType | null;
	allTemplates?: TemplateType[];
	block?: Page;
	page: Page;
	onClearTemplateClick?: () => void;
	loadingCriteriasList?: boolean;
	convertedTemplate: {
		value: any;
		label: string;
	}[];
}
